export const SOFIA_DISPLAY_NAME = "Sofia"

/**
 * How the product names the Sofia surface in chrome — the sidebar entry, its
 * `g h` command, and the top bar's breadcrumb. Prose about the assistant keeps
 * the bare `SOFIA_DISPLAY_NAME`.
 */
export const SOFIA_PRODUCT_NAME = "Sofia AI"

export const SOFIA_BIG_DOG_PROMPT = "You got this, big dog"

/**
 * The query param selecting which Sofia Home thread is shown. Not
 * workspace-scoped — `sofiaHome.ts`'s path builder deliberately preserves it
 * across a workspace path change, so anything else that rewrites the query
 * string on a workspace switch (`WorkspaceSwitcher`) must not drop it.
 */
export const SOFIA_THREAD_QUERY_PARAM = "sofia_thread"

/**
 * Sofia's panel layer. The panel is an opaque, fixed `<aside>` that floats over
 * the page, so it has to clear the chrome the page pins to the viewport (the
 * sticky navbar sits at `z-40`). It stays BELOW the `@coval/ui` overlay layer
 * (`z-50`) deliberately: a dialog or drawer is modal over the whole app, and a
 * panel painted on top of one leaves the user looking at a surface they cannot
 * click.
 *
 * That single rule covers both directions the panel is layered against.
 * Overlays the panel spawns, and app chrome the panel is not meant to cover,
 * both portal to `<body>` at the design-system default and so clear the panel
 * without opting into anything.
 */
export const SOFIA_PANEL_STACKING_CLASS = "z-[45]"
